<h1>Expense Search</h1>

<div class="formgrid grid">
    <div class="col-12 mb-4">
        <rc-generic-button label="Add New Expense" 
            id="button-add-expense" 
            level="secondary"
            size="large"
            (click)="onAddExpense()" />
    </div>
    <div class="col-6 field">
        <label class="field-label">Status</label>
        <p-dropdown placeholder="All" />
    </div>
    <div class="col-6 field">
        <label class="field-label">Approvals</label>
        <p-dropdown placeholder="All" />
    </div>
    <div class="col-6 field">
        <label class="field-label">Due Date</label>
        <p-calendar showIcon iconDisplay="input" dateFormat="mm/dd/yy" placeholder="MM/DD/YYY" ></p-calendar>
    </div>
    <div class="col-6 field">
        <label class="field-label">Keyword Search</label>
        <rc-input id="searchQuickfind" 
            type="text" 
            placeholder="i.e. vendor, invoice, etc."
            [control]="filterValue" />
        <!-- <button type="button" pButton icon="pi pi-search" class="btn-quickfind" (click)="onPageSearch()"></button> -->
    </div>
</div>

<div class="search-actions grid mb-3">
    <div class="col text-left">
        <p-button 
            label="Export" 
            (onClick)="onExportToExcel()" 
            id="button-export" 
            severity="secondary"
            styleClass="my-1" 
            class="ml-0"
            data-cy="btn-export">
        </p-button>
    </div>
    
    <div class="col text-right">
        <rc-generic-button 
            label="Clear All" 
            id="button-clear-filters" 
            borderStyle="outline"
            (click)="resetFilters()" 
            [classes]="['my-1']"
            data-cy="btn-clear"/>
        <rc-generic-button 
            label="Search" 
            id="button-search" 
            (click)="onSearch()"
            [classes]="['my-1 ml-1']"
            data-cy="btn-search"/>
    </div>
</div>

<!-- Use <p-dataView> for this? -->
<!-- Please retain the class expense-table-mobile class -->
<!-- <p-dataView styleClass="expense-table-mobile"></p-dataView> -->
<div class="expense-table-mobile p-dataview p-dataview-list">
    
    <p-card styleClass="card-style-mobile">
        <ng-template pTemplate="header">
            <div class="font-bold">$3,300.00</div>
            <div class="text-right font-light">04/12/2022</div>
        </ng-template>

        <dl class="expense-data-mobile">
            <!-- since they can't choose columns, display all available data rows -->
            <dt>Status</dt>
            <dd><p-tag severity="success" value="Approved"></p-tag></dd>

            <dt>Expense ID</dt>
            <dd><a href="#">098098089</a></dd>

            <dt>Due Date</dt>
            <dd>05/23/2022</dd>

            <dt>Vendor</dt>
            <dd>Abbvie Political Action Committee</dd>

            <dt>Description</dt>
            <dd>Lorem ipsum dolor amet</dd>

            <dt>Checkbook</dt>
            <dd>G14REV-87366</dd>

            <dt>Fund Code</dt>
            <dd>F2024</dd>

            <dt>Campaign</dt>
            <dd>Texans for Hurd</dd>
        </dl>


        <ng-template pTemplate="footer">
            <!-- Approvals and attachments -->
            <div class="">
                <button class="p-element p-button p-component p-button-icon-only bg-neutral-0 p-button-lg" type="button">
                    <span class="p-button-icon fa-sharp fa-solid fa-people-group redwood-60 ng-star-inserted" aria-hidden="true"></span>
                </button>

                <!-- <p-button [icon]="getGroupIcon(rowdata['ExpenseStatus'])"
                    styleClass="bg-neutral-0 p-button-lg"
                    (click)="getApprovalById(rowdata['ExpenseRequestId'], $event, my)">
                </p-button>

                <p-overlayPanel #my>
                    <div *ngIf="!showLoading && approvalsData.length > 0">
                        <p *ngFor="let approval of approvalsData">
                            <span *ngIf="approval.approvedDate">
                                <b>{{ approval.approvedBy }}</b>
                                ({{ approval.approvedDate | date: 'short' }})
                            </span>
                            <span *ngIf="!approval.approvedDate">
                                {{ approval.approvedBy }} &mdash;
                                <i>{{approval.status !== 'Approved' ? "Waiting" : ""}}</i>
                            </span>
                        </p>
                    </div>
                    <div *ngIf="!showLoading && approvalsData.length === 0">
                        <i>No approval needed.</i>
                    </div>
                </p-overlayPanel> -->

                <button class="p-ripple p-element p-button p-component p-button-icon-only bg-neutral-0 redwood-60" type="button">
                    <span class="p-button-icon fa-sharp fa-light fa-rectangle-list ng-star-inserted" aria-hidden="true"></span>
                </button>
                <!-- <p-button icon="fa-sharp fa-light fa-rectangle-list" (click)="cb.toggle($event)"
                    styleClass="bg-neutral-0 redwood-60">
                </p-button>

                <p-overlayPanel #cb>
                    <div style="max-width: 12rem;">
                        <p *ngFor="let glDetail of rowdata.GLDetails">{{ glDetail.glAccount }}</p>
                    </div>
                </p-overlayPanel> -->
            </div>

            <!-- Actions -->
            <div class="text-right">
                <button class="p-ripple p-element p-button p-component p-button-icon-only p-button-primary mx-1 p-button-icon-gray-light" disabled="" type="button">
                    <span class="p-button-icon fa-sharp fa-light fa-user-minus ng-star-inserted" aria-hidden="true"></span>
                </button>
                <button class="p-ripple p-element p-button p-component p-button-icon-only p-button-primary mx-1 p-button-icon-teal-medium" type="button">
                    <span class="p-button-icon fa-sharp fa-light fa-envelope-open-dollar ng-star-inserted" aria-hidden="true"></span>
                </button>
                <button class="p-ripple p-element p-button p-component p-button-icon-only p-button-primary mx-1 p-button-icon-red-light" type="button">
                    <span class="p-button-icon fa-sharp fa-light fa-trash-can ng-star-inserted" aria-hidden="true"></span>
                </button>
                
                <!-- <rc-generic-button [label]="
                    rowdata['AssignedToCurrentUser'] === '1' && rowdata['ExpenseStatus'] ==='Paid' ? 'My approval - locked' : 
                    rowdata['AssignedToCurrentUser'] === '1' && rowdata['MyApproval'] === '1' ? 'My approval - approved' : 
                    rowdata['AssignedToCurrentUser'] === '1' && (rowdata['MyApproval'] === '0') ? 'My approval - pending' : 
                    'My approval - not needed'" [iconImg]="
                    rowdata['AssignedToCurrentUser'] === '1' && rowdata['ExpenseStatus'] ==='Paid' ? 'user-check' : 
                    rowdata['AssignedToCurrentUser'] === '1'  && rowdata['MyApproval'] === '1'? 'user-check': 
                    rowdata['AssignedToCurrentUser'] === '1'  && rowdata['MyApproval'] === '0' ? 'user-clock' : 
                    'user-minus'" [iconColor]="
                    rowdata['AssignedToCurrentUser'] === '1' && rowdata['ExpenseStatus'] ==='Paid' ? 'gray-dark' : 
                    rowdata['AssignedToCurrentUser'] === '1'  && rowdata['MyApproval'] === '1'? 'teal-dark': 
                    rowdata['AssignedToCurrentUser'] === '1'  && rowdata['MyApproval'] === '0' ? 'teal-medium' : 
                    'gray-light'" [disabled]="rowdata['AssignedToCurrentUser'] !== '1'" [isIconOnly]="true"
                [classes]="['mx-1']"
                (clickHandler)="rowdata['AssignedToCurrentUser'] === '1'&&rowdata['MyApproval'] === '0' && expenseRequestApprove(rowdata.ExpenseRequestId)" />


            <rc-generic-button [label]="
                    rowdata['ExpenseStatus'] ==='Paid' ? 'RC Approval - sent for payment' : 
                    rowdata['ExpenseStatus'] ==='Approved' ? 'RC Approval - pending': 
                    'RC Approval - unapproved'" [iconImg]="
                    rowdata['ExpenseStatus'] ==='Paid' ? 'money-check' : 
                    rowdata['ExpenseStatus'] ==='envelope-dollar' ? 'envelope-dollar': 
                    'envelope-dollar'" [iconColor]="
                    rowdata['ExpenseStatus'] ==='Paid' ? 'teal-dark' : 
                    rowdata['ExpenseStatus'] ==='Approved' ? 'teal-medium' :
                    'gray-light'"
                [disabled]="rowdata['ExpenseStatus'] ==='Partial' || rowdata['ExpenseStatus'] ==='Unapproved'"
                [isIconOnly]="true" [classes]="['mx-1']"
                (clickHandler)="rowdata['ExpenseStatus'] ==='Approved' && sendforPayment(rowdata) || rowdata['ExpenseStatus'] ==='Paid' && unapprovePayment(rowdata) " />

            <rc-generic-button label="Delete" iconImg="trash" [iconColor]="'red-light'" [isIconOnly]="true"
                (clickHandler)="deleteExpenseRequest(rowdata.ExpenseRequestId)" [classes]="['mx-1']" /> -->
            </div>
        </ng-template>
    </p-card>

    <p-card styleClass="card-style-mobile">
        <ng-template pTemplate="header">
            <div class="font-bold">$3,300.00</div>
            <div class="text-right font-light">04/12/2022</div>
        </ng-template>

        <dl class="expense-data-mobile">
            <!-- since they can't choose columns, display all available data rows -->
            <dt>Status</dt>
            <dd><p-tag severity="success" value="Approved"></p-tag></dd>

            <dt>Expense ID</dt>
            <dd><a href="#">098098089</a></dd>

            <dt>Due Date</dt>
            <dd>05/23/2022</dd>

            <dt>Vendor</dt>
            <dd>Abbvie Political Action Committee</dd>

            <dt>Description</dt>
            <dd>Lorem ipsum dolor amet</dd>

            <dt>Checkbook</dt>
            <dd>G14REV-87366</dd>

            <dt>Fund Code</dt>
            <dd>F2024</dd>

            <dt>Campaign</dt>
            <dd>Texans for Hurd</dd>
        </dl>


        <ng-template pTemplate="footer">
            <!-- Approvals and attachments -->
            <div class="">
                <button class="p-element p-button p-component p-button-icon-only bg-neutral-0 p-button-lg" type="button">
                    <span class="p-button-icon fa-sharp fa-solid fa-people-group redwood-60 ng-star-inserted" aria-hidden="true"></span>
                </button>
                <button class="p-ripple p-element p-button p-component p-button-icon-only bg-neutral-0 redwood-60" type="button">
                    <span class="p-button-icon fa-sharp fa-light fa-rectangle-list ng-star-inserted" aria-hidden="true"></span>
                </button>
            </div>

            <!-- Actions -->
            <div class="text-right">
                <button class="p-ripple p-element p-button p-component p-button-icon-only p-button-primary mx-1 p-button-icon-gray-light" disabled="" type="button">
                    <span class="p-button-icon fa-sharp fa-light fa-user-minus ng-star-inserted" aria-hidden="true"></span>
                </button>
                <button class="p-ripple p-element p-button p-component p-button-icon-only p-button-primary mx-1 p-button-icon-teal-medium" type="button">
                    <span class="p-button-icon fa-sharp fa-light fa-envelope-open-dollar ng-star-inserted" aria-hidden="true"></span>
                </button>
                <button class="p-ripple p-element p-button p-component p-button-icon-only p-button-primary mx-1 p-button-icon-red-light" type="button">
                    <span class="p-button-icon fa-sharp fa-light fa-trash-can ng-star-inserted" aria-hidden="true"></span>
                </button>
            </div>
        </ng-template>
    </p-card>

</div>

<!-- TODO: include pagination here -->



